import UserProfilePageView from '@shared/userprofile/UserProfilePage';
import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { EntryLinksPage } from '../features/entry-links/EntryLinksPage';
import ExportConfiguration from '../features/export-configuration/ExportConfiguration';
import AdminRouter from '../main/conf/AdminRouter';
import { TagEditor } from '../main/conf/tageditor/TagEditor';
import { Dashboard } from '../main/dashboard/Dashboard';
import FlowManager from '../main/flow/FlowManager';
import ImportJobSingle from '../main/import/ImportJobSingle';
import ImportJobNew from '../main/import/ImportJobNew';
import ImportJobsList from '../main/import/ImportJobsList';
import RemoteJobs from '../main/remoteJobs/RemoteJobs';
import ErrorScreen from '../shared/errorpages/ErrorScreen';
import ClusterToSheet from './ClusterToSheet';
import Root from './Root';
var locationPageTitleMap = {
    '/sheet': 'Sheets | Farseer',
    '/dashboard': 'Dashboard | Farseer',
    '/import': 'Import | Farseer',
    '/database': 'Database | Farseer',
    '/remote-jobs': 'Remote Jobs | Farseer',
    '/admin': 'Admin | Farseer',
    '/myaccount': 'Profile | Farseer',
    '/export': 'Export | Farseer',
    '/entrylink': 'Entry Link | Farseer',
};
function AppRoutes() {
    var location = useLocation();
    useEffect(function () {
        var _a;
        var basePath = '';
        for (var i = 0; i < location.pathname.length; i++) {
            var char = location.pathname[i];
            if (char === '/' && i > 0) {
                break;
            }
            basePath += char;
        }
        var title = (_a = locationPageTitleMap[basePath]) !== null && _a !== void 0 ? _a : 'Farseer';
        document.title = title;
    }, [location.pathname, locationPageTitleMap]);
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "/", element: React.createElement(Root, null) },
            React.createElement(Route, { index: true, element: React.createElement(Navigate, { to: "sheet" }) }),
            React.createElement(Route, { path: "sheet", element: React.createElement(FlowManager, null) }),
            React.createElement(Route, { path: "sheet/:clusterPath", element: React.createElement(FlowManager, null) }),
            React.createElement(Route, { path: "dashboard", element: React.createElement(Dashboard, null) }),
            React.createElement(Route, { path: "dashboard/:selectedDocumentId", element: React.createElement(Dashboard, null) }),
            React.createElement(Route, { path: "import", element: React.createElement(ImportJobNew, null) }),
            React.createElement(Route, { path: "import/replace/:replaceImportJobId", element: React.createElement(ImportJobNew, null) }),
            React.createElement(Route, { path: "import/previous", element: React.createElement(ImportJobsList, null) }),
            React.createElement(Route, { path: "import/job/:importJobId", element: React.createElement(ImportJobSingle, null) }),
            React.createElement(Route, { path: "database", element: React.createElement(TagEditor, null) }),
            React.createElement(Route, { path: "database/:selectedGroupId", element: React.createElement(TagEditor, null) }),
            React.createElement(Route, { path: "database/:selectedGroupId/:selectedTableId", element: React.createElement(TagEditor, null) }),
            React.createElement(Route, { path: "remote-jobs", element: React.createElement(RemoteJobs, null) }),
            React.createElement(Route, { path: "admin/:sectionName", element: React.createElement(AdminRouter, null) }),
            React.createElement(Route, { path: "myaccount", element: React.createElement(UserProfilePageView, null) }),
            React.createElement(Route, { path: "export", element: React.createElement(ExportConfiguration, null) }),
            React.createElement(Route, { path: "entrylink/:entryLinkKey", element: React.createElement(EntryLinksPage, null) }),
            React.createElement(Route, { path: "cluster", element: React.createElement(ClusterToSheet, null) }),
            React.createElement(Route, { path: "cluster/:clusterPath", element: React.createElement(ClusterToSheet, null) }),
            React.createElement(Route, { path: "cluster/:clusterPath/:clusterSelected", element: React.createElement(ClusterToSheet, null) }),
            React.createElement(Route, { path: "*", element: React.createElement(ErrorScreen, null) }))));
}
export default AppRoutes;
